import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useBodyClasses = () => {
  const location = useLocation();

  useEffect(() => {
    const body = document.body;
    
    // Check if current path is a shop page
    const isShopPage = location.pathname.startsWith('/shop');
    const isBlogStandard = location.pathname === '/blog-standard' || location.pathname === '/blog-list' || location.pathname === '/blog-portfolio' || location.pathname === '/blog-grid';
    
    if (location.pathname === '/wishlist-page') {
      // Exact classes and attributes for Wishlist Page
      const wishlistClasses = [
        'wp-singular','page-template-default','page','page-id-6130','wp-custom-logo','wp-embed-responsive','wp-theme-printo','theme-printo','hide_fixed_rows_enabled','woocommerce-js','tinvwl-theme-style','skin_default','scheme_light','blog_mode_page','body_style_wide','is_single','sidebar_hide','expand_content','trx_addons_present','header_type_custom','header_style_header-custom-16729','header_position_default','menu_side_none','fixed_blocks_sticky','elementor-default','elementor-kit-15','e--ua-blink','e--ua-chrome','e--ua-webkit','ua_blink','ua_webkit','ua_chrome','animate_to_inited','added_to_cart_inited','desktop_layout'
      ];

      // Reset and apply exact classes
      body.className = '';
      body.classList.add(...wishlistClasses);

      // Set device mode
      body.setAttribute('data-elementor-device-mode', 'desktop');

      // Mouse move data attributes
      const parallaxElements = ['0df7043','edca655','0eda9d4','e0809a4','b4f90fd','04f1cc1','ad4b568','5d56f69'];
      parallaxElements.forEach(id => body.setAttribute(`data-mousemove-${id}`, id));
    } else if (location.pathname === '/product-single') {
      // Exact classes and attributes for Product Single
      const productSingleClasses = [
        'wp-singular','product-template-default','single','single-product','postid-2346','wp-custom-logo','wp-embed-responsive','wp-theme-printo','theme-printo','hide_fixed_rows_enabled','woocommerce','woocommerce-page','woocommerce-js','tinvwl-theme-style','skin_default','scheme_light','blog_mode_shop','body_style_wide','is_stream','blog_style_excerpt','sidebar_hide','expand_content','trx_addons_present','header_type_custom','header_style_header-custom-18015','header_position_default','menu_side_none','fixed_blocks_sticky','single_product_gallery_thumbs_left','elementor-default','elementor-kit-15','e--ua-blink','e--ua-chrome','e--ua-webkit','ua_blink','ua_webkit','ua_chrome','animate_to_inited','added_to_cart_inited','desktop_layout'
      ];

      // Reset and apply exact classes
      body.className = '';
      body.classList.add(...productSingleClasses);

      // Set device mode
      body.setAttribute('data-elementor-device-mode', 'desktop');

      // Mouse move data attributes
      const parallaxElements = ['0df7043','edca655','0eda9d4','e0809a4','b4f90fd','04f1cc1','ad4b568','5d56f69'];
      parallaxElements.forEach(id => body.setAttribute(`data-mousemove-${id}`, id));
    } else if (isShopPage) {
      // Shop page body classes - exact classes as specified
      const shopClasses = [
        'archive',
        'post-type-archive',
        'post-type-archive-product',
        'wp-custom-logo',
        'wp-embed-responsive',
        'wp-theme-printo',
        'theme-printo',
        'hide_fixed_rows_enabled',
        'woocommerce-shop',
        'woocommerce',
        'woocommerce-page',
        'woocommerce-js',
        'tinvwl-theme-style',
        'skin_default',
        'scheme_light',
        'blog_mode_shop',
        'body_style_wide',
        'is_stream',
        'blog_style_excerpt',
        'sidebar_show',
        'sidebar_right',
        'sidebar_small_screen_below',
        'trx_addons_present',
        'header_type_custom',
        'header_style_header-custom-18015',
        'header_position_default',
        'menu_side_none',
        'fixed_blocks_sticky',
        'elementor-default',
        'elementor-kit-15',
        'e--ua-blink',
        'e--ua-chrome',
        'e--ua-webkit',
        'ua_blink',
        'ua_webkit',
        'ua_chrome',
        'animate_to_inited',
        'added_to_cart_inited',
        'desktop_layout'
      ];

      // Reset body class to empty to prevent class persistence from previous routes
      body.className = '';
      
      // Add shop classes
      body.classList.add(...shopClasses);
      
      // Add mouse move data attributes for parallax elements
      const parallaxElements = [
        '0df7043', 'edca655', '0eda9d4', 'e0809a4', 
        'b4f90fd', '04f1cc1', 'ad4b568', '5d56f69'
      ];
      
      parallaxElements.forEach(elementId => {
        body.setAttribute(`data-mousemove-${elementId}`, elementId);
      });
      
      // Set elementor device mode
      body.setAttribute('data-elementor-device-mode', 'desktop');
    } else if (location.pathname === '/blog/single-post/standard') {
      // Exact classes and attributes for Single Post Standard
      const singlePostClasses = [
        'wp-singular','post-template-default','single','single-post','postid-2801','single-format-standard','wp-custom-logo','wp-embed-responsive','wp-theme-printo','theme-printo','hide_fixed_rows_enabled','woocommerce-js','tinvwl-theme-style','skin_default','scheme_light','blog_mode_post','body_style_wide','is_single','single_style_style-5','sidebar_show','sidebar_right','sidebar_small_screen_below','trx_addons_present','header_type_custom','header_style_header-custom-17824','header_position_default','menu_side_none','fixed_blocks_sticky','elementor-default','elementor-kit-15','e--ua-blink','e--ua-chrome','e--ua-webkit','ua_blink','ua_webkit','ua_chrome','animate_to_inited','added_to_cart_inited','desktop_layout'
      ];

      // Reset classes to set exact required ones
      document.body.className = '';
      document.body.classList.add(...singlePostClasses);

      // Set elementor device mode
      document.body.setAttribute('data-elementor-device-mode', 'desktop');

      // Mouse move data attributes
      const parallaxElements = ['0df7043','edca655','0eda9d4','e0809a4','b4f90fd','04f1cc1','ad4b568','5d56f69'];
      parallaxElements.forEach(id => document.body.setAttribute(`data-mousemove-${id}`, id));
    } else if (location.pathname === '/blog/single-post/without-sidebar') {
      // Exact classes and attributes for Single Post Without Sidebar
      const singlePostWithoutSidebarClasses = [
        'wp-singular','post-template-default','single','single-post','postid-2808','single-format-standard','wp-custom-logo','wp-embed-responsive','wp-theme-printo','theme-printo','hide_fixed_rows_enabled','woocommerce-js','tinvwl-theme-style','skin_default','scheme_light','blog_mode_post','body_style_wide','is_single','single_style_style-5','sidebar_hide','narrow_content','trx_addons_present','header_type_custom','header_style_header-custom-17824','header_position_default','menu_side_none','fixed_blocks_sticky','elementor-default','elementor-kit-15','e--ua-blink','e--ua-chrome','e--ua-webkit','ua_blink','ua_webkit','ua_chrome','animate_to_inited','added_to_cart_inited','desktop_layout'
      ];

      // Reset classes to set exact required ones
      document.body.className = '';
      document.body.classList.add(...singlePostWithoutSidebarClasses);

      // Set elementor device mode
      document.body.setAttribute('data-elementor-device-mode', 'desktop');

      // Mouse move data attributes
      const parallaxElements = ['0df7043','edca655','0eda9d4','e0809a4','b4f90fd','04f1cc1','ad4b568','5d56f69'];
      parallaxElements.forEach(id => document.body.setAttribute(`data-mousemove-${id}`, id));
    } else if (location.pathname === '/blog-grid') {
      // Exact classes for Blog Grid
      const blogGridClasses = [
        'archive','category','category-insights','category-99','wp-custom-logo','wp-embed-responsive','wp-theme-printo','theme-printo',
        'hide_fixed_rows_enabled','woocommerce-js','tinvwl-theme-style','skin_default','scheme_light','blog_mode_blog','body_style_wide',
        'is_stream','blog_style_classic_3','blog_template','sidebar_hide','expand_content','trx_addons_present','header_type_custom',
        'header_style_header-custom-16729','header_position_default','menu_side_none','fixed_blocks_sticky','elementor-default',
        'elementor-kit-15','e--ua-blink','e--ua-chrome','e--ua-webkit','ua_blink','ua_webkit','ua_chrome','animate_to_inited',
        'added_to_cart_inited','desktop_layout'
      ];

      // Remove home-like conflicting classes
      const homeConflicting = [
        'home','wp-singular','page-template-default','page','page-id-5002','frontpage','blog_mode_front','body_style_fullscreen',
        'sidebar_show','expand_content','header_style_header-custom-19489','header_position_over','elementor-page','elementor-page-5002',
        'sc_layouts_row_fixed_inited','mobile_device'
      ];
      body.classList.remove(...homeConflicting);

      // Apply classes
      blogGridClasses.forEach(c => body.classList.add(c));

      // Parallax and device mode
      const parallaxElements = ['0df7043','edca655','0eda9d4','e0809a4','b4f90fd','04f1cc1','ad4b568','5d56f69'];
      parallaxElements.forEach(id => body.setAttribute(`data-mousemove-${id}`, id));
      body.setAttribute('data-elementor-device-mode', 'desktop');
    } else if (location.pathname === '/blog-portfolio') {
      // Exact classes for Blog Portfolio
      const blogPortfolioClasses = [
        'archive','category','category-insights','category-99','wp-custom-logo','wp-embed-responsive','wp-theme-printo','theme-printo',
        'hide_fixed_rows_enabled','woocommerce-js','tinvwl-theme-style','skin_default','scheme_light','blog_mode_blog','body_style_wide',
        'is_stream','blog_style_portfolio_3','blog_template','sidebar_hide','expand_content','trx_addons_present','header_type_custom',
        'header_style_header-custom-16729','header_position_default','menu_side_none','fixed_blocks_sticky','elementor-default',
        'elementor-kit-15','e--ua-blink','e--ua-chrome','e--ua-webkit','ua_blink','ua_webkit','ua_chrome','animate_to_inited',
        'added_to_cart_inited','desktop_layout'
      ];

      const homeConflicting = [
        'home','wp-singular','page-template-default','page','page-id-5002','frontpage','blog_mode_front','body_style_fullscreen',
        'sidebar_show','expand_content','header_style_header-custom-19489','header_position_over','elementor-page','elementor-page-5002',
        'sc_layouts_row_fixed_inited','mobile_device'
      ];
      body.classList.remove(...homeConflicting);

      blogPortfolioClasses.forEach(c => body.classList.add(c));

      const parallaxElements = ['0df7043','edca655','0eda9d4','e0809a4','b4f90fd','04f1cc1','ad4b568','5d56f69'];
      parallaxElements.forEach(id => body.setAttribute(`data-mousemove-${id}`, id));
      body.setAttribute('data-elementor-device-mode', 'desktop');

    } else if (location.pathname === '/checkout') {
      // Exact classes and attributes for Checkout Page
      const checkoutClasses = [
        'wp-singular','page-template-default','page','page-id-2333','wp-custom-logo','wp-embed-responsive','wp-theme-printo',
        'theme-printo','hide_fixed_rows_enabled','woocommerce-checkout','woocommerce-page','woocommerce-js','tinvwl-theme-style',
        'skin_default','scheme_light','blog_mode_shop','body_style_wide','is_stream','blog_style_excerpt','sidebar_hide',
        'expand_content','trx_addons_present','header_type_custom','header_style_header-custom-18015','header_position_default',
        'menu_side_none','fixed_blocks_sticky','elementor-default','elementor-kit-15','e--ua-blink','e--ua-chrome','e--ua-webkit',
        'ua_blink','ua_webkit','ua_chrome','animate_to_inited','added_to_cart_inited','desktop_layout'
      ];

      // Reset and apply exact classes
      body.className = '';
      body.classList.add(...checkoutClasses);

      // Set device mode
      body.setAttribute('data-elementor-device-mode', 'desktop');

      // Mouse move data attributes
      const parallaxElements = ['0df7043','edca655','0eda9d4','e0809a4','b4f90fd','04f1cc1','ad4b568','5d56f69'];
      parallaxElements.forEach(id => body.setAttribute(`data-mousemove-${id}`, id));
    } else if (isBlogStandard) {
      // Desired classes for Blog Standard & List
      const blogClassesToAdd = [
        'blog','wp-custom-logo','wp-embed-responsive','wp-theme-printo','theme-printo','hide_fixed_rows_enabled',
        'woocommerce-js','tinvwl-theme-style','skin_default','scheme_light','blog_mode_home','body_style_wide',
        'is_stream','blog_style_excerpt','sidebar_show','sidebar_right','sidebar_small_screen_below','trx_addons_present',
        'header_type_custom','header_style_header-custom-16729','header_position_default','menu_side_none','fixed_blocks_sticky',
        'elementor-default','elementor-kit-15','e--ua-blink','e--ua-chrome','e--ua-webkit','ua_blink','ua_webkit','ua_chrome',
        'animate_to_inited','added_to_cart_inited','desktop_layout'
      ];

      const homeConflicting = [
        'home','wp-singular','page-template-default','page','page-id-5002','frontpage','blog_mode_front','body_style_fullscreen',
        'sidebar_hide','expand_content','header_style_header-custom-19489','header_position_over','elementor-page','elementor-page-5002',
        'sc_layouts_row_fixed_inited','mobile_device'
      ];

      body.classList.remove(...homeConflicting);
      blogClassesToAdd.forEach(c => body.classList.add(c));

      // Parallax data attributes for decorative elements
      const parallaxElements = ['0df7043','edca655','0eda9d4','e0809a4','b4f90fd','04f1cc1','ad4b568','5d56f69'];
      parallaxElements.forEach(id => body.setAttribute(`data-mousemove-${id}`, id));
      body.setAttribute('data-elementor-device-mode', 'desktop');

    } else {
      // Default/home-like classes
      const homeClassesToAdd = [
        'home','wp-singular','page-template-default','page','page-id-5002','wp-custom-logo','wp-embed-responsive','wp-theme-printo',
        'theme-printo','hide_fixed_rows_enabled','frontpage','woocommerce-js','tinvwl-theme-style','skin_default','scheme_light',
        'blog_mode_front','body_style_fullscreen','is_stream','blog_style_excerpt','sidebar_hide','expand_content','trx_addons_present',
        'header_type_custom','header_style_header-custom-19489','header_position_over','menu_side_none','fixed_blocks_sticky',
        'elementor-default','elementor-kit-15','elementor-page','elementor-page-5002','e--ua-blink','e--ua-chrome','e--ua-webkit',
        'ua_retina','ua_blink','ua_webkit','ua_chrome','animate_to_inited','sc_layouts_row_fixed_inited','added_to_cart_inited',
        'desktop_layout','mobile_device'
      ];

      const blogConflicting = [
        'blog','blog_mode_home','body_style_wide','sidebar_show','sidebar_right','sidebar_small_screen_below',
        'header_style_header-custom-16729','header_position_default'
      ];

      body.classList.remove(...blogConflicting);
      homeClassesToAdd.forEach(c => body.classList.add(c));

      // Remove shop-specific classes when not on shop pages
      const shopClasses = [
        'archive',
        'post-type-archive',
        'post-type-archive-product',
        'woocommerce-shop',
        'woocommerce',
        'woocommerce-page',
        'woocommerce-js',
        'tinvwl-theme-style',
        'blog_mode_shop',
        'sidebar_show',
        'sidebar_right',
        'sidebar_small_screen_below',
        'header_style_header-custom-18015'
      ];
      
      body.classList.remove(...shopClasses);
      
      // Remove parallax data attributes
      const parallaxElements = [
        '0df7043', 'edca655', '0eda9d4', 'e0809a4', 
        'b4f90fd', '04f1cc1', 'ad4b568', '5d56f69'
      ];
      
      parallaxElements.forEach(elementId => {
        body.removeAttribute(`data-mousemove-${elementId}`);
      });

      // Home wants tablet per provided snippet
      body.setAttribute('data-elementor-device-mode', 'tablet');
    }

    // Cleanup function
    return () => {
      // This will run when component unmounts or location changes
      // The next useEffect will handle setting the correct classes
    };
  }, [location.pathname]);
};
